import { pipe } from "fp-ts/function";
import * as RA from "fp-ts/ReadonlyArray";
import * as Fold from "../fold";
const compose_ = (f1, f2) => Fold.fold((fold, empty, a) => pipe(Fold.toArray(f1, a), RA.chain((b) => Fold.toArray(f2, b)), RA.reduceRight(empty, fold)));
export function compose(f, ...fs) {
    return fs.reduce((f1, f2) => compose_(f1, f2), f);
}

